module.exports = __webpack_public_path__ + "img/logo.5b7be5a7.png";